import { GrLinkNext } from "react-icons/gr";
import SubLineProduct from "./SubLineProduct.jsx";
import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import Loader from "utils/Loader.jsx";

export default function ParentSubLine({
  selectedItem,
  changeSelectedItem,
  selectedInformation,
  dataLine,
  linesList,
  subLine,
  productList,
  paramId,
  products,
}) {
  const [selectedFilter, setSelectedFilter] = useState("0");
  const [activeButton, setActiveButton] = useState(-1);
  const [product, setProduct] = useState([]);
  const [isLoading, setISLoading] = useState(false);
  useEffect(() => {
    setProduct(products);
    // console.log("products", products);
  }, [products]);
  const filter = (names) => {
    if (linesList.length > 0) {
      let temp = linesList.filter(
        (d) => d.main.suppliers_line__id == selectedItem
      );
      switch (names) {
        case "title":
          return temp[0].main.title;
          break;
        case "path":
          return temp[0].main.path;
          break;
      }
    }
  };
  // const productList = (id) => {
  //   setISLoading(true);
  //   connection("api/get_products", {
  //     supplier_id: paramId,
  //     sub_line_id: id,
  //   }).then((data) => {
  //     setProduct(data);
  //   });
  //   setISLoading(false);
  // };
  // console.log("product", product);
  // console.log("linesList", linesList);
  // console.log("paramId", paramId);
  // console.log("subLine", subLine);
  return (
    <>
      {isLoading && <Loader />}
      <div className="" style={{ padding: " 50px 6% 20px" }}>
        <div className="d-flex mt-3 pr-4 overflow overflow-auto pb-4">
          <div
            style={{
              alignSelf: "center",
              marginLeft: "10px",
            }}
          >
            <GrLinkNext
              onClick={() => {
                changeSelectedItem(-1);
                selectedInformation();
              }}
              style={{ cursor: "pointer" }}
            ></GrLinkNext>
          </div>
          <div
            style={{
              alignSelf: "center",
              fontWeight: "bold",
              fontSize: "18px",
              whiteSpace: "nowrap",
            }}
          >
            {filter("title")}
          </div>
          <div className="d-flex">
            <div>
              <button
                className={`btn-sub    ${
                  activeButton === -1 && "  selected-btn"
                }`}
                id="allProduct"
                // ${selectedItem == index && "active-box"}
                onClick={(e) => {
                  // setSelectedFilter(value.suppliers_line__id);
                  // productList(value.suppliers_line__id);
                  // productList();
                  setActiveButton(-1);
                  setProduct(products);
                  productList(subLine.main.suppliers_line__id, "apiLine");
                }}
              >
                همه
              </button>
            </div>
            {subLine.sublines.map((value, index) => {
              return (
                <div>
                  <button
                    className={`btn-sub ${
                      activeButton === index && "  selected-btn"
                    }
                 `}
                    onClick={(e) => {
                      setSelectedFilter(value.suppliers_line__id);
                      // productList(value.suppliers_line__id);
                      setActiveButton(index);
                      productList(value.suppliers_line__id, "apiSubLine");
                      // console.log("value", value.suppliers_line__id);
                    }}
                  >
                    {value.title}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        <SubLineProduct
          // data={selectedInformation.data}
          data={product}
          selectedFilter={selectedFilter}
        ></SubLineProduct>
      </div>
    </>
  );
}
